<template>
  <div id="creditEvaluationDetail">
    <div class="flex row top-bar_wrapper">
      <div
        class="progress-name progress-name-active pointer"
      >外部信用评价
      </div>
    </div>
    <div
      class="flex flex1 justify-between item-center button-title__box"
    >
      <div class="flex justify-start">
        <GreenButton
          :options="{
                    borderColor: 'rgba(26,89,184,0.33)',
                    borderRadius: '5px',
                    color: '#1A59B8 !important'
          }"
          class="button__cancel button__gap"
          text="返回"
          @click="backChange"
        ></GreenButton>
        <GreenButton
          class="button__default"
          text="填报"
          @click="createChange"
        ></GreenButton>
      </div>
      <el-select
        v-model="categoryName"
        class="flex justify-end items-center"
        placeholder="请选择"
        size="small"
        @change="categoryChange"
      >
        <el-option
          v-for="({ label, value },categoryIndex) in categoryNameOptions"
          :key="`${label}-${value}-${categoryIndex}`"
          :label="label"
          :value="value"
        ></el-option>
      </el-select>
    </div>
    <el-table
      :data="dataList"
      :header-cell-style="{background: 'rgba(0,0,0,0.02)',borderTop:'1px solid rgba(0,0,0,0.1)'}"
      :loading="loading"
      class="table-box"
      height="calc(100% - 165px)"
    >
      <el-table-column
        label="项目名称"
        prop="ProjectName"
      ></el-table-column>
      <el-table-column
        label="项目经理"
        prop="Manager"
        width="140"
      ></el-table-column>
      <el-table-column
        label="本次得分"
        prop="CurrentScore"
        width="120"
      ></el-table-column>
      <el-table-column
        label="本次排名"
        prop="CurrentRank"
        width="120"
      ></el-table-column>
      <el-table-column
        label="上次得分"
        prop="LastScore"
        width="120"
      ></el-table-column>
      <el-table-column
        label="上次排名"
        prop="LastRank"
        width="120"
      ></el-table-column>
      <el-table-column
        label="评价变化"
        prop="Change"
        width="140"
      ></el-table-column>
      <el-table-column
        label="操作"
        width="160"
      >
        <template #default="scope">
          <el-link
            type="primary"
            @click="editInfo(scope.row)"
          >
            编辑
          </el-link>
          <el-link
            style="margin-left: 1em;"
            type="primary"
            @click="deleteInfo(scope.row)"
          >
            删除
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <div
      class="table-box__pagination flex flex1 justify-end items-center"
    >
      <el-pagination
        :current-page.sync="pageIndex"
        :page-size.sync="pageSize"
        :total="allTotal"
        layout="total, prev, pager, next"
        @current-change="onPageIndexChange"
      ></el-pagination>
    </div>
    <CreditEvaluationDialog
      :id="currentID"
      :category="categoryName"
      :is-edit="isCreateEdit"
      :object="this.Evaluation_INFO()"
      :visible="createDialogVisible"
      @closeDialog="onImportDialogClose"
      @refresh="onRefreshDialogClose"
    ></CreditEvaluationDialog>
  </div>
</template>
<script>
import GreenButton from '@/components/buttons/GreenButton'
import CreditEvaluationDialog from '@/components/dialog/CreditEvaluationDialog'
import { mapGetters, mapMutations } from 'vuex'

let _this = void 0

export default {
  name: 'creditEvaluationDetail',
  mixins: [],
  components: { GreenButton, CreditEvaluationDialog },
  props: {},
  data() {
    return {
      pageIndex: 1,
      pageSize: 11,
      allTotal: 0,
      loading: false,
      dataList: [],
      createDialogVisible: false,
      isCreateEdit: false,
      currentID: -1,
      categoryName: '',
      categoryNameOptions: [],
      currentYear: '',//当前年
      currentType: ''//上半年 or 下半年
    }
  },
  computed: {
    //...mapState('', {}),
  },
  watch: {},
  filters: {
    timeDateFilter(date) {
      return typeof date === 'string' ? date.split('T')[0] : ''
    },
  },
  directives: {},
  created() {
    _this = this
  },
  async mounted() {
    const { Type, Year } = this.Evaluation_INFO()
    this.currentType = Type
    this.currentYear = Year
    await this.getCategoryInfo()
    await this.getDataInfo()
  },
  destroy() {
  },
  methods: {
    //...mapMutations('', []),
    ...mapMutations({
      setRouter: 'setRouter'
    }),
    ...mapGetters('management', {
      Evaluation_INFO: 'CreditEvaluationInfo',
    }),
    /**
     * 获取 外部信用评价类型 数据
     * */
    async getCategoryInfo() {
      const { success, data } = await this.$http({
        url: this.$api.getQueryCategory,
        params: {
          year: this.currentYear,
          type: this.currentType
        }
      })
      if (success) {
        this.categoryNameOptions = []
        data.map((item) => {
          this.categoryNameOptions.push({ label: item, value: item })
        })
        this.categoryNameOptions.unshift({ label: '全部类型', value: '' })
      }
    },
    /**
     * 获取 外部信用评价 数据
     * */
    async getDataInfo() {
      this.loading = true
      const { success, data } = await this.$http({
        url: this.$api.getPageQueryCreditEvaluation,
        params: {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize,
          year: this.currentYear,
          category: this.categoryName,
          type: this.currentType
        }
      })
      if (success) {
        const { rows, total } = data
        if (data.hasOwnProperty('rows')) {
          this.dataList = [...rows]
          if (data.hasOwnProperty('total')) {
            this.allTotal = total
          }
        }
      }
      this.loading = false
    },
    /**
     * 切换分页
     * */
    onPageIndexChange(pageIndex) {
      this.pageIndex = pageIndex
      this.getDataInfo()
    },
    /**
     * 下拉选择
     * */
    categoryChange(value) {
      this.pageIndex = 1
      this.categoryName = value
      this.getDataInfo()
    },
    /**
     * 填报 选择
     * */
    createChange() {
      this.createDialogVisible = true
    },
    /**
     * 返回 选择
     * */
    async backChange() {
      await this.setRouter({ name: 'CreditEvaluation' })
    },
    /**
     * 填报 关闭dialog回调
     * */
    onImportDialogClose(type) {
      this.isCreateEdit = false
      this.createDialogVisible = false
    },
    /**
     * 填报 刷新dialog回调
     * */
    onRefreshDialogClose(type) {
      this.isCreateEdit = false
      this.createDialogVisible = false
      this.pageIndex = 1
      this.getDataInfo()
    },
    /**
     * 编辑信息
     * */
    editInfo(item) {
      const { ID } = item
      this.currentID = ID
      this.isCreateEdit = true
      this.createDialogVisible = true
    },
    /**
     * 删除信息
     * */
    deleteInfo(item) {
      const { ID } = item
      this.$confirm('是否确认删除', '删除外部信用评价', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        beforeClose: (action, instance, done) => {
          if (action === 'confirm') {
            instance.confirmButtonLoading = true
            instance.confirmButtonText = '删除中...'
            setTimeout(async () => {
              await this.deleteChange(ID)
              done()
              setTimeout(() => {
                instance.confirmButtonLoading = false
              }, 300)
            }, 300)
          }
          else {
            done()
          }
        }
      })
    },
    /**
     * 确认删除
     * */
    async deleteChange(ID) {
      const { success } = await this.$http({
        url: this.$api.goDeleteCreditEvaluation,
        params: {
          id: ID
        }
      })
      if (success) {
        this.$message.success('删除成功')
        this.pageIndex = 1
        await this.getDataInfo()
      }
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
#creditEvaluationDetail {
  height: 100%;
}

::v-deep .el-link.el-link--primary {
  color: #005BAC;
}
</style>
<style lang="scss"></style>
